module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-US":{"delete":"Remove this question","delete_alert":"Are you sure you want to remove this question?","read_more":"Read more"},"pt-BR":{"delete":"Remover esta pergunta","delete_alert":"Tem certeza que deseja remover esta pergunta?","read_more":"Continuar lendo"}}')
  delete Component.options._Ctor
}
